import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var LineDrawer = /*#__PURE__*/function () {
  function LineDrawer() {
    _classCallCheck(this, LineDrawer);
  }
  _createClass(LineDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 1;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      context.moveTo(-radius / 2, 0);
      context.lineTo(radius / 2, 0);
    }
  }]);
  return LineDrawer;
}();